import type { DeviceSessionDto, OrganizationMemberDto } from './types'

import { apiRequest } from './client'
import { buildDeviceLabel, getOrCreateDeviceId } from '../auth/deviceId'

export type InviteMemberPayload = {
  email: string
  first_name?: string
  last_name?: string
  job_title_preset?: 'manager' | 'purchaser' | 'chef'
  venue_ids?: number[]
}

export type UpdateMemberPayload = {
  job_title?: string
  job_title_preset?: 'manager' | 'purchaser' | 'chef'
  permissions?: string[]
  venue_ids?: number[]
}

export const listDeviceSessions = () => apiRequest<DeviceSessionDto[]>('/auth/sessions')

export const revokeDeviceSession = (sessionId: number) =>
  apiRequest<void>(`/auth/sessions/${sessionId}`, { method: 'DELETE' })

export const listOrganizationMembers = (organizationId: number) =>
  apiRequest<OrganizationMemberDto[]>(`/organizations/${organizationId}/members`)

export const inviteOrganizationMember = (organizationId: number, payload: InviteMemberPayload) =>
  apiRequest<OrganizationMemberDto>(`/organizations/${organizationId}/members`, {
    method: 'POST',
    body: payload,
  })

export const updateOrganizationMember = (
  organizationId: number,
  memberId: number,
  payload: UpdateMemberPayload,
) =>
  apiRequest<OrganizationMemberDto>(`/organizations/${organizationId}/members/${memberId}`, {
    method: 'PATCH',
    body: payload,
  })

export const authDevicePayload = () => ({
  device_id: getOrCreateDeviceId(),
  device_label: buildDeviceLabel(),
})
